<template>
  <div>
    Placeholder for single chart view
  </div>
</template>

<script>
export default {
  name: 'Chart'
}
</script>
